import styles from "./DeliveryTicks.module.css";

type Props = {
  status?: "pending" | "sent" | "delivered" | "read" | "failed";
};

export function DeliveryTicks({ status }: Props) {
  if (!status || status === "pending") {
    return (
      <span className={styles.ticks} aria-label="pending">
        🕐
      </span>
    );
  }
  if (status === "failed") {
    return (
      <span className={`${styles.ticks} ${styles.failed}`} aria-label="failed">
        !
      </span>
    );
  }
  const read = status === "read";
  const label = status === "sent" ? "sent" : read ? "read" : "delivered";
  return (
    <span className={`${styles.ticks} ${read ? styles.read : ""}`} aria-label={label}>
      ✓✓
    </span>
  );
}
